// Rolecosplay Halloween delivery reminder. Remove after the 2026 campaign.
(() => {
  if (window.__rolecosHalloweenPopup2026) return;
  window.__rolecosHalloweenPopup2026 = true;

  const DESTINATION = 'https://rolecosplay.com/collections/big-clearance';
  const SEEN_KEY = 'rolecos-halloween-delivery-popup-2026-10-22';
  const DAY = 24 * 60 * 60 * 1000;

  function beforeDeadline() {
    return new Date() < new Date(2026, 9, 25);
  }
  if (!beforeDeadline()) return;

  function wasSeenRecently() {
    try {
      return Date.now() - Number(localStorage.getItem(SEEN_KEY) || 0) < DAY;
    } catch (_) {
      return false;
    }
  }
  function markSeen() {
    try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch (_) {}
  }
  if (wasSeenRecently()) return;

  function show() {
    if (!beforeDeadline() || wasSeenRecently() || document.getElementById('rolecos-halloween-popup-2026')) return;
    const style = document.createElement('style');
    style.id = 'rolecos-halloween-popup-2026-style';
    style.textContent = `
      #rolecos-halloween-popup-2026{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(18,9,25,.62);font-family:Arial,Helvetica,sans-serif}
      #rolecos-halloween-popup-2026 *{box-sizing:border-box}
      #rolecos-halloween-popup-2026 .rc-box{position:relative;width:min(700px,100%);max-height:calc(100vh - 40px);overflow:auto;padding:48px 40px 30px;border-radius:17px;background:#fff;box-shadow:0 18px 46px rgba(19,8,28,.28);text-align:center;color:#38333c}
      #rolecos-halloween-popup-2026 h2{margin:0 24px 24px;color:#d97326;font-size:clamp(26px,4vw,36px);line-height:1.18;font-weight:700}
      #rolecos-halloween-popup-2026 p{margin:0 auto 20px;max-width:620px;font-size:19px;line-height:1.5}
      #rolecos-halloween-popup-2026 strong{color:#d97326;font-weight:700}
      #rolecos-halloween-popup-2026 .rc-cta{display:block;width:100%;padding:17px 20px;border-radius:12px;background:#f58220;color:#fff!important;font-size:19px;font-weight:700;text-decoration:none;line-height:1.2}
      #rolecos-halloween-popup-2026 .rc-cta:hover,#rolecos-halloween-popup-2026 .rc-cta:focus{background:#df7116}
      #rolecos-halloween-popup-2026 .rc-dismiss{display:block;margin:19px auto 16px;padding:4px 12px;border:0;background:transparent;color:#d97326;font-size:16px;cursor:pointer}
      #rolecos-halloween-popup-2026 .rc-close{position:absolute;top:12px;right:14px;border:0;background:transparent;color:#746b78;font-size:32px;line-height:1;cursor:pointer}
      #rolecos-halloween-popup-2026 small{display:block;color:#6e6870;font-size:13px;line-height:1.4}
      @media(max-width:540px){#rolecos-halloween-popup-2026 .rc-box{padding:40px 21px 25px}#rolecos-halloween-popup-2026 p{font-size:17px}#rolecos-halloween-popup-2026 .rc-cta{font-size:17px}}
    `;
    document.head.appendChild(style);

    const overlay = document.createElement('div');
    overlay.id = 'rolecos-halloween-popup-2026';
    overlay.innerHTML = `
      <section class="rc-box" role="dialog" aria-modal="true" aria-labelledby="rc-halloween-title">
        <button class="rc-close" type="button" aria-label="Close popup">×</button>
        <h2 id="rc-halloween-title">🎃 Halloween Is Almost Here!</h2>
        <p>Need it by Halloween? <strong>Order by Oct 24.</strong><br>
        Choose <strong>Ready to Ship</strong> and <strong>2–3 day shipping</strong> at checkout for the best chance of arriving in time.</p>
        <a class="rc-cta" href="${DESTINATION}">Shop Ready to Ship →</a>
        <button class="rc-dismiss" type="button">No, thanks</button>
        <small>Delivery depends on your location. Check the estimated date at checkout.</small>
      </section>`;
    function dismiss() {
      markSeen();
      overlay.remove();
      style.remove();
      document.removeEventListener('keydown', onKeydown);
    }
    function onKeydown(event) {
      if (event.key === 'Escape') dismiss();
    }
    overlay.querySelector('.rc-close').addEventListener('click', dismiss);
    overlay.querySelector('.rc-dismiss').addEventListener('click', dismiss);
    overlay.querySelector('.rc-cta').addEventListener('click', markSeen);
    overlay.addEventListener('click', event => { if (event.target === overlay) dismiss(); });
    document.addEventListener('keydown', onKeydown);
    document.body.appendChild(overlay);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(show, 2500), {once: true});
  } else {
    setTimeout(show, 2500);
  }
})();
